<template>
  <div class="yobb" role="region" :aria-label="ariaLabel">
    <div class="yobb__icon-wrap" aria-hidden="true">
      <img
        class="give-badge-warning-icon"
        :src="require('@components/assets/notify-outer.svg')"
        alt="warning icon"
        width="35"
        height="35"
        object-fit="contain"
      />
    </div>
    <div class="yobb__content">
      <h2 class="yobb__title">
        You have {{ obsoleteBadgeCount }} Obsolete
        {{ obsoleteBadgeCount === 1 ? "Badge" : "Badges" }}
      </h2>
      <p class="yobb__body">
        {{ description }}
      </p>
      <button type="button" class="yobb__action" @click="onActionClick">
        {{ actionLabel }}
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from "vue";

const props = defineProps({
  obsoleteBadgeCount: {
    type: Number,
    default: 0,
    validator: (n) => Number.isInteger(n) && n >= 0,
  },
  description: {
    type: String,
    default:
      "Some of your badges are obsolete, meaning that they have not yet passed checkpoints for the current badge level. There is a grace period for you to get your obsolete badges back in good standing, otherwise they will expire at the end of the grace period.",
  },
  actionLabel: {
    type: String,
    default: "Show your obsolete badges",
  },
});

const emit = defineEmits(["show-obsolete-badges"]);

const ariaLabel = computed(() => `Obsolete badges: ${props.obsoleteBadgeCount}`);

function onActionClick() {
  emit("show-obsolete-badges");
}
</script>

<style scoped>
.yobb {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  border-radius: 8px;
  border: 1px solid #dfe1e6;
  background: #ffffff;
}

.yobb__icon-wrap {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 0;
  position: relative;
  top: -7px;
}

.yobb__icon {
  display: block;
}

.yobb__content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.yobb__title {
  margin: 0;
  padding: 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #344054;
}

.yobb__body {
  margin: 4px 0 0;
  padding: 0;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #475467;
}

.yobb__action {
  margin: 8px 0 0;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: #6941c6;
  text-align: left;
  text-decoration: none;
}
.yobb__action:focus-visible {
  outline: 2px solid #5e5ce6;
  outline-offset: 2px;
  border-radius: 2px;
}
</style>
